import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

		if(window.innerWidth < 1024) {
			this.el.classList.add('is-swippable');

			this.slidesCount =  this.el.querySelectorAll('.swiper-slide').length;

			this.swiper = new Swiper(this.el, {
				// speed: 800,
				spaceBetween: 12,
				loop: this.slidesCount > 2,
				slidesPerView: 1.2
			});
		}
    }
	

}
